import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allSchemasTemplate } from "../../store/certificates/actions";
export var GetAllSchemasTemplate = function (trigger) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        loadingSchemasTemplate: state.Certificates.loadingSchemasTemplate,
        responseSchemasTemplate: state.Certificates.responseSchemasTemplate,
        errorSchemasTemplate: state.Certificates.errorSchemasTemplate,
    }); }), loadingSchemasTemplate = _a.loadingSchemasTemplate, responseSchemasTemplate = _a.responseSchemasTemplate, errorSchemasTemplate = _a.errorSchemasTemplate;
    useEffect(function () {
        if (trigger) {
            dispatch(allSchemasTemplate());
        }
    }, [trigger]);
    return {
        loadingSchemasTemplate: loadingSchemasTemplate,
        responseSchemasTemplate: responseSchemasTemplate,
        errorSchemasTemplate: errorSchemasTemplate,
    };
};
